<template>
<div class="home">
  <Head id="cms-title" :show="loginType==2?'admin':''" :title="goodBanner.cmsUserName"></Head>
  <div class="kong">&nbsp;</div>
  <swiper class="lunbo-box" ref="mySwiper" :options="swiperOption" v-if="goodBanner.newBanners&&goodBanner.newBanners.length" >
    <swiper-slide v-for="(item, index) in goodBanner.newBanners"   :key="'banner'+index">
      <img
        :id="'poster_' + index"
        :src="item.url"
        v-if="item.type==1"
        @click.stop="handlePlayVideo(item.type,index,item.url)"
        alt
      />
      <img
        @click.stop="handlePlayVideo(item.type,index,item.url)"
        :class="{'hidden':curLunboIdx == index}"
        :id="'poster_' + index"
        :src="item.cover"
        v-if="item.type==2"
        alt
      />
      <img id="video-icon" v-if="item.type==2&&!show" @click.stop="handlePlayVideo(item.type,index,item.url)" :src="require('@/assets/images/icon_banner_play.98b6099.png')" class="swiper_mobile_video_icon--2Z8FQ">
      <div class="video-box" :id="'video-box_' + index" v-if="item.type==2">
        <video
          :id="'video_' + index"
          class="video"
          preload="preload"
          :playsinline="true"
          :webkit-playsinline="true"
          :x5-playsinline="true"
          :x-webkit-airplay="true"
          :x5-video-player-fullscreen="true"
          x5-video-orientation="portraint"
          loop="loop"
          @click.stop="videoBtn(item.type,index,item.url)"
        >
          <source :src="item.url" type="video/mp4" />
          <source :src="item.url" type="video/ogg" />暂不支持视频播放，请升级浏览器
        </video>
      </div>
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination" ></div>
  </swiper>

  <!-- 库存管理 -->
  <h3 class="address" v-if="goodBanner.address">
    <span class="code">机器编号：{{goodBanner.deviceNum }}
      &nbsp;&nbsp;&nbsp;&nbsp;地址: {{goodBanner.address}}</span>
  </h3>
  <!-- 账户余额 -->
  <div class="balance" v-if='loginType==2'>
    <!-- <template v-if="userInfo.cmsUserId&&userToken">
      <van-button class="inventory" type="default" @click="toInventory">库存管理</van-button>
    </template>
    <template v-else>
      <span>
        您的账户余额 :
        <span class="balance_price_min">￥</span>
        <span class="balance_price">{{personal.userMoney}}</span>
        元
      </span>
      <van-button class="recharge" type="info" @click="toRecharge">会员充值</van-button>
    </template> -->
    <template v-if="userToken">
      <span>
        您的账户余额 :
        <span class="balance_price_min">￥</span>
        <span class="balance_price">{{personal.userMoney}}</span>
        元
      </span>
      <van-button class="recharge" type="info" @click="toRecharge">会员充值</van-button>
    </template>
    <!-- <template v-if="userToken">
      <van-button class="inventory" type="default" @click="toInventory">库存管理</van-button>
    </template> -->
  </div>
  <!-- <div class="choujiang_box" @click.stop="goLottery">
    <img :src="require('@/assets/images/choujiang.png')" alt="">
  </div> -->
  <div class="good-grid">
    <van-grid :gutter="10"  :border="false" :column-num="2">
        <van-grid-item v-for="(item,index) in dataList" :key="index">
          <van-image :src="item.mainImage"/>
          <div class="good-data">
            <h3>{{item.goodTitle}}</h3>
            <van-row>
              <van-col span="24"><span>库存：</span><span> {{item.currentStock}}</span></van-col>
            </van-row>
            <van-row>
              <van-col span="24"><span>价格：</span><span style="color:#2d77f2;">￥<span class="good-data_price">{{item.cellPrice||item.goodPrice}}</span></span></van-col>
            </van-row>
            <van-button class="carry-out" :disabled="!item.currentStock>0"  plain type="primary" @click="goGoodDetails(item)">{{item.currentStock>0?'立即购买':'库存不足'}}</van-button>
          </div>
        </van-grid-item>
    </van-grid>
  </div>
  <vueToTop :size='30' :type='8' :top='50' color='#13A556' :bottom='40'></vueToTop>
  <login-modal ref="login"/>
  <coupon-modal />
  <receive-award-modal ref="receiveAwardModal" />
  <audio id="myaudio" v-if="goodBanner.audio" autoplay loop><source :src="goodBanner.audio.url"></audio>
</div>
</template>
<script>
import LoginModal from "@/components/LoginModal";
import {mapState} from "vuex";
import "swiper/css/swiper.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import CouponModal from "@/components/CouponModal";
import ReceiveAwardModal from "@/components/ReceiveAwardModal";
import { Toast } from "vant";
export default {
name:"home",
components: {
  LoginModal:LoginModal,
  Swiper,
  SwiperSlide,
  CouponModal,
  ReceiveAwardModal
},
computed:{
  ...mapState(['personal','user'])
},
mounted() {
  this.getgoodList()
  this.getGoodBanner()
  setInterval(() =>{
    if(this.box_index){
        let q_video = document.getElementById("video_" + (this.box_index-1));
        let paused =q_video.paused
        if(q_video){
          if(!paused){
            this.show=true
          }else{
            this.show=false
            this.box_index=''
            this.$refs.mySwiper.$swiper.autoplay.start()
          }
        }
    }
  }, 1000);
  if (this.$route.query.activityType) {
    this.getActivity(this.$route.query)
  } 
  if(this.user.ticket){
    this.getFocusCoupons()
  }
},
beforeDestroy() {
  if(this.timer) {
    window.clearInterval(this.timer); //关闭
  }
},
data() {
  return {
    page_size:10,
    page_num:1,
    box_index:'',
    show:false,
    timer:null,
    goodBanner:{
      // newBanners:[
      //  {"type":2,"delete":1,"createTime":"2020-12-09T09:42:26","updateTime":"2020-12-09T15:14:17","cmsUserId":4,"url":"https://cmsuser.oss-cn-hangzhou.aliyuncs.com/2020120910012001website_20209_1603851081944.mp4","sort":1,"title":"蓝月亮","id":10,"content":"<p>cs</p>","cover":"https://cmsuser.oss-cn-hangzhou.aliyuncs.com/2020120910012001lyl.jpg"},
      //  {"type":1,"delete":1,"createTime":"2020-12-06T22:19:39","updateTime":"2020-12-08T17:30:46","cmsUserId":4,"url":"https://cmsuser.oss-cn-hangzhou.aliyuncs.com/banner1.jpg","sort":1,"title":"banner1","id":1,"content":"<p>cs</p>","cover":null},
      //  {"type":1,"delete":1,"createTime":"2020-12-06T22:19:39","updateTime":"2020-12-06T22:54:04","cmsUserId":4,"url":"https://cmsuser.oss-cn-hangzhou.aliyuncs.com/banner2.jpg","sort":2,"title":"banner2","id":2,"content":null,"cover":null},
      // ]
    },
    curLunboIdx: -1, //当前轮播索引
    swiperOption: {//轮播选项配置
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      loop: false, //循环
      autoplay: {
        delay: 2000 //每张播放时长2秒，自动播放
      },
      speed: 1500, //滑动速度
      on:{
        // 轮播切换后，上一个swiper-slie有视频，则暂停
        slideNextTransitionStart:function(){
          let index = this.activeIndex;
          let box = this.$wrapperEl[0];
          let slide = box.getElementsByClassName('swiper-slide')[index-1];
            var myAuto = document.getElementById('myaudio');
          if(slide){
            var child = slide.children;
          }
          if(child.length==2){
            let video = child[1].children[0];
            myAuto.play();
            video.pause();
          }
        },
        slidePrevTransitionStart:function(){
          let index = this.activeIndex;
          let box = this.$wrapperEl[0];
          let slide = box.getElementsByClassName('swiper-slide')[index+1];
          var myAuto = document.getElementById('myaudio');
          if(slide){
            var child = slide.children;
          }
          if(child.length==2){
            let video = child[1].children[0];
            myAuto.play();
            video.pause();
          }
        },
      },
    },
    isUpLoading: false,
    upFinished: false,
    dataList:[],
  }
},

beforeRouteLeave(to, from, next) {
  this.handlePauseVideo();
  next()
},
methods: {
  getFocusCoupons(){
      const params={
        deviceNum: this.deviceNum,
        ticket: this.user.ticket
      }
      this.$api.coupon.getFocusCoupons(params).then(res => {
        if (res.code == 200) {
         if(res.result&&res.result.length>0 ){
          this.$store.dispatch('submitTicket','')
          this.$refs.receiveAwardModal.title = '关注成功'
          this.$refs.receiveAwardModal.showModal(res.result)
         }
        }
      })
    },
    // 优惠券查询
    getActivity(v) {
      const params={
        orderNo:v.orderNo,
        deviceNum: this.deviceNum,
        activityId: v.activityId,
        activityType: v.activityType,
      }
      this.$api.coupon.getActivity(params).then(res => {
        if(res.code==200 &&res.result&&res.result.length>0){
          this.$refs.receiveAwardModal.showModal(res.result)
        }
      })
    },
  // 视频播放
  handlePlayVideo(type,index, url) {
    this.curLunboIdx = index;
    if (type ==2 && url) {
      let c_video_box = document.getElementById("video-box_" + index);
      let c_video = document.getElementById("video_" + index);
        var myAuto = document.getElementById('myaudio');
      c_video_box.style.zIndex = 5;
      if(c_video){
        c_video.style.display = "block"
        this.box_index=index+1
        this.show=true
        this.$refs.mySwiper.$swiper.autoplay.stop()
        myAuto.pause();
        c_video.play();
      };
    }
  },
  videoBtn(type,index, url){
      this.curLunboIdx = index;
      if (type ==2 && url) {
      let c_video_box = document.getElementById("video-box_" + index);
      let c_video = document.getElementById("video_" + index);
      var myAuto = document.getElementById('myaudio');
      c_video_box.style.zIndex = 5;
      let paused =c_video.paused
      if(!paused){
        if(c_video){
          this.show=false
          this.$refs.mySwiper.$swiper.autoplay.start()
          this.box_index=''
          myAuto.play();
          c_video.pause();

        }
      }else{
        if(c_video){
          this.show=true
          this.box_index=index+1
          this.$refs.mySwiper.$swiper.autoplay.stop()
          myAuto.pause();
          c_video.play();
        };
      }
    }
  },
  // 视频暂停
  handlePauseVideo(){
    let vList = document.querySelectorAll(".video-box video");
    for(var i=0;i<vList.length;i++){
      vList[i].pause();
    }
  },
  // 图片跳转
  toJump(data) {
    if (data.value) {
      window.location.href = data.value
    }
  },
  getGoodBanner(){
      let data={
      deviceNum:this.deviceNum
    }
    this.$api.good.goodBanner(data).then((res)=>{
      const title = res.cmsUserName || '智能零售商城';
      document.title = title;
      this.goodBanner = res
      this.$store.dispatch('submitOrgTitle',this.goodBanner.cmsUserName)
      if (!this.userToken && this.deviceNum&&this.loginType==2) {
        if(!this.user.popNo){
          this.$store.dispatch('submitPopNo',true)
          this.$refs.login.showModal()
        }
      }
    })
  },
  getgoodList(){
    let data={
      deviceNum:this.deviceNum
    }
    this.$api.good.goodList(data).then((res)=>{
      if(res.code==200){
        this.dataList=res.dataList
      }else{
          Toast(res.msg)
      }
    })

  },
  gotoHome(idx){

  },
  goGoodDetails(row){
      let data ={
        id:row.id,
        goodId:row.goodId
      }
      this.$router.push({name: 'goodDetails', query: data})
  },
  // 上拉加载
  onLoadList() {
    if(this.upFinished==false){
      setTimeout( ()=>{
        this.page_num+=1
        this.getDataList()
      }, 1000)
    }
  },
  //去往库存管理
  toInventory(){
    if(this.userToken){
      this.$router.push({
        name: 'inventory'
      })
    }else{
      this.$refs.login.control()
    }
  },
  goLottery() {
    if(this.userToken){
      this.$router.push({name: 'lottery'})
    }else{
      this.$refs.login.control()
    }
  },
  toRecharge() {
    if(this.userToken){
        this.$router.push({name: 'recharge'})
    }else{
      this.$refs.login.control()
    }
  }
},

};
</script>
<style scoped>
.home{
width: 100%;
background-color:#f7f8fa;
}
.kong{
width: 100%;
height: 100px;
}

.home .lunbo-box {
position: relative;
width:100%;
height:470px;
}
img {
width: 100%;
height:470px;
position: relative;
z-index: 4;
}
.swiper_mobile_video_icon--2Z8FQ{
position: absolute;
width: 50px;
height: 50px;
left: 50%;
top: 50%;
transform: translate(-50%,-50%);
cursor: pointer;
z-index: 9999;
}
.hidden {
display: none;
}
.video-box {
position: absolute;
top: 0;
width:100%;
height:470px;
z-index: 3;
}
.video-box .video {
width:100%;
height:470px;
object-fit: cover;
display: none;
}
.home /deep/ .swiper-pagination .swiper-pagination-bullet-active {
background: #ffffff;
}
.home /deep/ .swiper-pagination-bullet-active{
background-color:#8dc2fc;
}
.home .good-grid {
width: 100%;
padding-bottom: 10px;
}
.home .good-grid /deep/ .van-grid-item__content{
box-shadow: 0 8px 12px #ebedf0;
}
.home .good-grid /deep/ .van-image{
height: 300px;
}
.home .good-grid .van-image  /deep/ img{
height: 300px;
width: 100%;
}
.good-data{
text-align: left;
width: 100%;
box-sizing: border-box;
padding: 10px 10px 0 10px;
}
.good-data h3{
font-size: 32px;
font-weight: bold;
color:#000000;
margin:4px 0;
}
.good-data .van-row .van-col /deep/.good-data_price{
font-size: 30px !important;
}
.good-data .van-row .van-col{
font-size: 24px;
}
.good-data /deep/.van-row{
margin:4px 0;
}
.home .good-grid  /deep/ .van-grid-item__content--center{
align-items:flex-start;
}
.home .good-grid /deep/ .carry-out{
float: right;
margin-right:10px;
margin-top: 10px;
border-radius: 6px;
border: 2px solid #00963e;
font-size: 26px;
height: 55px;
line-height: 55px;
}
.address{
width: 100vw;
box-sizing: border-box;
padding: 20px 20px;
font-weight: 600;
font-size: 26px;
display: flex;
justify-content: space-between;
align-items: center;
}
.inventory{
padding: 0 15px;
height: 55px;
line-height: 55px;
margin-left: 10px;
background: #888888;
color:#f5f5f5;
border-radius: 10px;
font-size: 24px;
}
.code{
display: inline-block;
/* background-color: rgb(224, 224, 224); */
border-radius:20px;
font-size: 26px;
}

.balance{
width: 100%;
height: 80px;
line-height: 80px;
box-sizing: border-box;
padding: 0 20px;
margin-bottom: 15px;
color: #000000;
}
.balance span{
font-size: 24px;
}
.balance .balance_price{
color:#2d77f2;
font-size: 32px;
}
.balance .balance_price_min{
color:#2d77f2;
}
.balance .recharge{
margin-left: 30px;
padding: 0 15px;
height: 55px;
line-height: 55px;
border-radius: 10px;
font-size: 24px;
}
.choujiang_box{
  width: 100%;
  height: 230px;
  box-sizing:border-box;
  padding: 0px 8px 8px;
}
.choujiang_box img{
  width: 100%;
  height: 100%;
}
</style>
